module.exports = __webpack_public_path__ + "assets/images/animations/hearthy-animation.webp?2329fead";